export default __webpack_public_path__ + "static/media/ellipse_testimony_one.7dfb4973.svg";